import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-stroke-width',
    templateUrl: './stroke-width.component.html',
    styleUrl: './stroke-width.component.scss',
    imports: [AsyncPipe]
})
export class StrokeWidthComponent {
    readonly strokeWidth$ = this.store.select(fromToolbar.selectStrokeWidth);

    constructor(
        private store: Store
    ) { }

    selectStrokeWidth(strokeWidth: number) {
        if (strokeWidth === undefined) {
            throw new Error(`Invalid stroke width "${strokeWidth}"`);
        }
        this.store.dispatch(
            ToolbarActions.strokeWidthSelected({ strokeWidth: strokeWidth })
        );
        // this.store.dispatch(
        //     ToolbarActions.activateDrawingTool({toolName: 'pencil'})
        // );
    }
}
